module.exports = __webpack_public_path__ + "img/manager-avatar.0fb6c78.png";